import React from 'react'
import { Section } from '@/components/frontend/atoms/layout/Section'
import { Container } from '@/components/frontend/atoms/layout/Container'
import { TwoColumn } from '@/components/frontend/atoms/layout/TwoColumn'
import { Stack } from '@/components/shared/atoms/layout/Stack'
import { SectionIntro } from '@/components/frontend/molecules/SectionIntro'
import { ContactForm } from '@/components/frontend/molecules/ContactForm'
import { ContactInfo } from '@/components/frontend/molecules/ContactInfo'
import { useTranslation } from '@/hooks/useTranslation'
import type { ContactFormProps } from '@/components/frontend/molecules/ContactForm'

interface ContactSectionProps {
  form: ContactFormProps
  headingLevel?: 'h1' | 'h2'
}

export const ContactSection: React.FC<ContactSectionProps> = ({ form, headingLevel = 'h2' }) => {
  const { t } = useTranslation()

  return (
    <Section padding="lg" id="contatti">
      <Container>
        <Stack gap="12">
          <SectionIntro
            label={t('contact.label')}
            title={t('contact.heading')}
            subtitle={t('contact.subheading')}
            as={headingLevel}
          />
          <TwoColumn split="narrow-wide" gap="8" alignItems="start">
            <ContactInfo />
            <ContactForm {...form} />
          </TwoColumn>
        </Stack>
      </Container>
    </Section>
  )
}
